import React from 'react';
import { TopBar } from './components/TopBar';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FeaturesSection } from './components/FeaturesSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TrustSection } from './components/TrustSection';
import { ProductSection } from './components/ProductSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-0" data-mp="2wiyy8vkq9zd9">
      <TopBar data-id="element-1" data-mp="2wi5pxq64f1t0" />
      <Header data-id="element-2" data-mp="28u5ysp4wd9dw" />
      <HeroSection data-id="element-3" data-mp="28tmg367fagyt" />
      <ProblemSection data-id="element-4" data-mp="28t4l0cwhy8sh" />
      <FeaturesSection data-id="element-5" data-mp="28sbbj465l56n" />
      <ComparisonSection data-id="element-6" data-mp="23vci6nubd29i" />
      <TrustSection data-id="element-7" data-mp="23w4e5zrtp20b" />
      <ProductSection data-id="element-8" data-mp="23ujl6el5pr4k" />
      <TestimonialsSection data-id="element-9" data-mp="23t8i6gzjcnei" />
      <FaqSection data-id="element-10" data-mp="3ik7g4ghnibqn" />
      <CtaSection data-id="element-11" data-mp="3ikr0e3urxc7u" />
      <Footer data-id="element-12" data-mp="3ij66mgga9xb1" />
    </div>;
}